var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group mt-2" }, [
    _c(
      "label",
      { staticClass: "form-label", attrs: { for: "cluster_company" } },
      [_vm._v("\n        Виберiть з випадаючого списку Організацію\n    ")]
    ),
    _vm._v(" "),
    _vm.draw_items.length > 0
      ? _c(
          "div",
          {},
          [
            _c(
              "v-select",
              {
                staticClass: "imc_reasons",
                attrs: {
                  id: "cluster_company",
                  reduce: (item) => item.company,
                  label: "company",
                  options: this.draw_items,
                  filterable: false,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function (option) {
                        return [
                          _c("div", { staticClass: "d-center" }, [
                            _c("b", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.company) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "small" }, [
                              _vm._v(
                                "\n                        USERS_IN: " +
                                  _vm._s(option.count) +
                                  "\n                    "
                              ),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  744307901
                ),
                model: {
                  value: _vm.active_company,
                  callback: function ($$v) {
                    _vm.active_company = $$v
                  },
                  expression: "active_company",
                },
              },
              [
                _c("template", { slot: "no-options" }, [
                  _vm._v("\n                Оберіть організацію\n            "),
                ]),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }